/// <reference path="../../../Commands/RequestCertificateCommand.ts"/>

module EEX.McEc.Controls.CertificateDialog {

    import RequestCertificateCommand = McEc.Commands.RequestCertificateCommand;
    import RequestCertificateState = McEc.Commands.RequestCertificateState;

    // ReSharper disable once InconsistentNaming
    export interface UploadCSRAndRequestCertificateAttribute extends CertificateDialogBaseAttribute {
        state: RequestCertificateState;
    }

    // ReSharper disable once InconsistentNaming
    export class UploadCSRAndRequestCertificateModel extends CertificateDialogBaseModel<UploadCSRAndRequestCertificateAttribute> {

        private requestCertificateCommand: RequestCertificateCommand;

        constructor(model: CertificateDialogModel, processStep: number, requestCertificateCommand: RequestCertificateCommand) {
            super(model, processStep);

            this.requestCertificateCommand = requestCertificateCommand;
        }

        public createCsr() {
            if (!this.get().canContinue) {
                const store = this.model.get().store;
                const certificateAttribute = this.model.get().certificateAttributes;
                const isServerCertificate = this.model.get().isServerCertificate;
                this.requestCertificateCommand.request(store, certificateAttribute, isServerCertificate, (state) => this.stateChanged(state));
            }
        }

        private stateChanged(state: RequestCertificateState): void {
            this.set({ state: state });
            if (state === RequestCertificateState.ErrorCsrUploaded
                || state === RequestCertificateState.CertificateRequested
                || state === RequestCertificateState.CertificateDownloaded
                || state === RequestCertificateState.Timeout) {
                this.canComplete();
            } else if (state === RequestCertificateState.Success) {
                this.model.set({ certificateFile: this.requestCertificateCommand.getCertificateFile() });
                this.model.set({ certificateKey: this.requestCertificateCommand.getCertificateKey() });
                this.canContinue();
            }
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface UploadCSRAndRequestCertificateOptions extends CertificateDialogBaseOptions {
    }

    // ReSharper disable once InconsistentNaming
    export class UploadCSRAndRequestCertificateView extends CertificateDialogBaseView<UploadCSRAndRequestCertificateModel> {
        model: UploadCSRAndRequestCertificateModel;

        private containers: {
            loader: HTMLElement,
        }

        private elements: {
            info: JQuery,
            finishedInfo: JQuery,
            timeoutInfo: JQuery,
            errorInfo: JQuery,
            loader: JQuery,
            csrUploaded: JQuery,
            certificateRequested: JQuery,
            certificateDownloaded: JQuery,
        }

        constructor(model: UploadCSRAndRequestCertificateModel, target: HTMLElement, options?: UploadCSRAndRequestCertificateOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_UploadCrsAndRequestCertificate,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_UploadCrsAndRequestCertificate_Title
                    }));

            this.model.on("change:state",
                () => {
                    this.stateChanged(this.model.get().state);
                });
        } 

        render() { 
            super.render();
            this.setContainers();
            this.setElements();
            this.createLoader();
            this.showContent(this.model.get().canContinue);

            this.elements.timeoutInfo.hide();
            this.elements.errorInfo.hide();

            this.model.createCsr();
            return this;
        }

        private setContainers(): void {
            this.containers = {
                loader: this.$el.find(".upload-crs-and-request-certificate-loader-container")[0]
            }
        }

        private setElements(): void {
            this.elements = {
                info: this.$el.find(".upload-crs-and-request-certificate-info"),
                finishedInfo: this.$el.find(".upload-crs-and-request-fnished-uploaded-info"),
                timeoutInfo: this.$el.find(".upload-crs-and-request-timeout-info"),
                errorInfo: this.$el.find(".upload-crs-and-request-error-info"),
                loader: this.$el.find(".upload-crs-and-request-certificate-loader-container"),
                csrUploaded: this.$el.find(".a-info-state-csr-uploaded"),
                certificateRequested: this.$el.find(".a-info-state-certificate-requested"),
                certificateDownloaded: this.$el.find(".a-info-state-certificate-downloaded"),
            }
        } 

        private createLoader(): void {
            AppKitchen.UIHelper.renderLoader(this.containers.loader, { type: "circle" });
        }

        private showContent(canContinue: boolean): void {
            this.toggleContentVisibility(this.elements.finishedInfo, canContinue);
            this.toggleContentVisibility(this.elements.loader, !canContinue);
            this.toggleContentVisibility(this.elements.info, !canContinue);
        }

        private stateChanged(state: RequestCertificateState): void {
            switch (state) {
                case RequestCertificateState.Success:
                    this.showContent(this.model.get().canContinue);
                    break;
                case RequestCertificateState.Timeout:
                    this.timeout();
                    break;
                case RequestCertificateState.CsrUploaded:
                    this.updateStateIcon(this.elements.csrUploaded);
                    break;
                case RequestCertificateState.CertificateRequested:
                    this.updateStateIcon(this.elements.certificateRequested);
                    break;
                case RequestCertificateState.CertificateDownloaded:
                    this.updateStateIcon(this.elements.certificateDownloaded);
                    break;
                case RequestCertificateState.ErrorCsrUploaded:
                    this.updateStateError(this.elements.csrUploaded);
                    break;
                case RequestCertificateState.ErrorCertificateRequested:
                    this.updateStateError(this.elements.certificateRequested);
                    break;
                case RequestCertificateState.ErrorCertificateDownloaded:
                    this.updateStateError(this.elements.certificateDownloaded);
                    break;
                default:
            }
        }

        private updateStateError(e: JQuery): void {
            e.find(".mesap-icon").removeClass("icon-status-waiting");
            e.find(".mesap-icon").removeClass("icon-status-ok");
            e.find(".mesap-icon").addClass("icon-status-fail");

            this.error();
        }

        private updateStateIcon(e: JQuery): void {
            e.find(".mesap-icon").removeClass("icon-status-waiting");
            e.find(".mesap-icon").removeClass("icon-status-fail");
            e.find(".mesap-icon").addClass("icon-status-ok");
        }

        private timeout(): void {
            this.toggleContentVisibility(this.elements.finishedInfo, false);
            this.toggleContentVisibility(this.elements.loader, false);
            this.toggleContentVisibility(this.elements.errorInfo, false);
            this.toggleContentVisibility(this.elements.timeoutInfo, true);
            this.toggleContentVisibility(this.elements.info, true);
        }

        private error(): void {
            this.toggleContentVisibility(this.elements.finishedInfo, false);
            this.toggleContentVisibility(this.elements.loader, false);
            this.toggleContentVisibility(this.elements.timeoutInfo, false);
            this.toggleContentVisibility(this.elements.errorInfo, true);
            this.toggleContentVisibility(this.elements.info, true);
        }
    }
}